export default __webpack_public_path__ + "static/media/TWO2x.9b57b430.jpg";